import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  Output,
  OnDestroy
} from '@angular/core';
import { Subscription, Subject, takeUntil } from 'rxjs';
import { ContactSalesComponent } from 'src/app/common/components/contact-sales/contact-sales.component';
import { SharedService } from 'src/app/common/services/shared.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { CommonPropertyDetailConstant } from '../common-property-detail-page.constant';
import { CommonPropertyDetailPageService } from '../common-property-detail-page.service';
import { MatDialog } from '@angular/material/dialog';
import { CommonPropertyDetailMenuEnum } from '../common-property-detail-page.enum';

@Component({
  selector: 'app-warehouse-rental-details-table',
  templateUrl: './warehouse-rental-details-table.component.html',
  styleUrls: ['./warehouse-rental-details-table.component.scss'],
})
export class WarehouseRentalDetailsTableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() property_uid: string = '';
  overViewMenu = CommonPropertyDetailConstant.overViewMenu;
  tableColumns: any[] = CommonPropertyDetailConstant.warehouseColumns;
  tableData: any[] = [];
  showLoader: boolean = false;
  current_lang: string = 'en';

  private destroy$ = new Subject<void>();
  private languageSub$: Subscription = new Subscription();

  
  @Output() isEmpatyCheck = new EventEmitter();

  constructor(
    private sharedService: SharedService,
    private reportService: ReportService,
    private propertyService: CommonPropertyDetailPageService,
    private matDialog: MatDialog
  ) {
    this.languageSub$ = this.sharedService.language$.subscribe((lang) => {
      this.current_lang = lang;
    });
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['property_uid']?.currentValue) {
      this.fetchData();
    }
  }

  fetchData(): void {
    this.showLoader = true;
    this.propertyService
      .getPropertyRental(20, 0, '', this.property_uid, 'warehouse')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.showLoader = false;

          if (res.status === 200) {
            this.tableData = this.reportService.setTableDataSource(res.data);
            this.isEmpatyCheck.emit(false);
          } else {
            this.tableData = [];
            this.isEmpatyCheck.emit(true);
          }
        },
        error: () => {
          this.showLoader = false;
          this.tableData = [];
          this.isEmpatyCheck.emit(true);
        },
      });
  }

  openContactSales() {
    this.matDialog.open(ContactSalesComponent, {
      width: '600px',
      maxHeight: '95vh',
      panelClass: 'contact-form',
      data: { Type: 'contact_us' },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.languageSub$.unsubscribe();
  }
}
